import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle, ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edades funciona?',
  a: 'Está diseñado para mujeres de 25 a 60 años que sufren cansancio, estrés e inflamación.'
}, {
  q: '¿Viene con plan de comidas?',
  a: 'Sí. Incluye 30 recetas sin gluten, lácteos ni azúcar refinada.'
}, {
  q: '¿Necesito equipo o suplementos caros?',
  a: 'No. Solo necesitás acceso a internet y ganas de cambiar.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Muchas notan cambios en energía en 2 semanas. Resultados completos: 60-90 días.'
}, {
  q: '¿Hay garantía?',
  a: '100% garantía 30 días. Si no funciona, te devolvemos todo.'
}, {
  q: '¿Es un programa online o coaching 1 a 1?',
  a: 'Es un programa online con acceso de por vida. No es coaching individual.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-darker border-y border-brand-border" data-id="element-130">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-131">
        <FadeIn className="text-center mb-12" data-id="element-132">
          <HelpCircle className="w-12 h-12 text-brand-terracotta mx-auto mb-4" data-id="element-133" />
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark" data-id="element-134">
            Preguntas que nos hacen constantemente
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-135">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-136">
              <div className={`bg-brand-card border ${openIndex === i ? 'border-brand-terracotta' : 'border-brand-border'} rounded-xl overflow-hidden transition-colors shadow-card`} data-id="element-137">
                <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none gap-4" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-138">
                  <span className="flex items-start gap-3 font-bold text-brand-dark pr-2" data-id="element-139">
                    <span className="text-brand-terracotta text-lg leading-tight shrink-0" data-id="element-140">
                      ❓
                    </span>
                    <span data-id="element-141">{faq.q}</span>
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-terracotta shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-142" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
                  <p className="text-brand-muted leading-relaxed pl-8 border-l-2 border-brand-border ml-1" data-id="element-144">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}